export const isIterable = obj => {
  // checks for null and undefined
  if (obj == null) return false
  return typeof obj[Symbol.iterator] === 'function'
}

export const mergeCollections = (col1, col2 = [], iteratee) => col1?.map(obj => ({ ...obj, ...col2.find(o => o[iteratee] === obj[iteratee]) }))

export const sleep = milliseconds => new Promise(resolve => setTimeout(resolve, milliseconds))
